import React from 'react';

const WhatsAppButton = () => {
  // Reemplaza este número con el de tu cliente (incluye el código de país sin el símbolo +)
  const phoneNumber = "573102390002"; 
  const message = "Hola, me gustaría recibir más información sobre las propiedades."; // Mensaje opcional

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      // Clases de Tailwind para fijarlo abajo a la derecha y darle estilos
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-16 h-16 bg-[#25D366] text-white rounded-full shadow-lg hover:bg-[#1ebe57] hover:scale-110 transition-all duration-300"
      aria-label="Contactar por WhatsApp"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 24 24"
        className="w-8 h-8"
      >
        <path d="M11.999 0C5.373 0 0 5.373 0 12c0 2.115.549 4.108 1.516 5.864L.016 24l6.297-1.481A11.922 11.922 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 11.999 0zm0 21.993c-1.802 0-3.52-.464-5.045-1.341l-.361-.21-3.738.879.897-3.642-.23-.377A9.917 9.917 0 012.007 12C2.007 6.486 6.486 2.007 12 2.007c5.513 0 9.993 4.479 9.993 9.993 0 5.514-4.48 9.993-9.993 9.993zm5.492-7.513c-.301-.151-1.783-.88-2.06-.98-.277-.101-.48-.151-.682.151-.202.302-.781.98-.957 1.182-.176.202-.353.227-.655.076-1.503-.761-2.617-1.424-3.626-3.174-.176-.303.176-.282.464-.852.1-.201.05-.378-.025-.529-.076-.151-.682-1.643-.933-2.25-.245-.591-.494-.51-.682-.52-.176-.01-.378-.01-.58-.01-.202 0-.529.076-.806.378-.277.302-1.058 1.033-1.058 2.518 0 1.485 1.084 2.92 1.235 3.121.151.201 2.13 3.253 5.158 4.558 1.944.836 2.709.914 3.655.766.744-.117 2.27-.927 2.597-1.821.327-.894.327-1.66.23-1.821-.097-.161-.353-.252-.655-.403z" />
      </svg>
    </a>
  );
};

export default WhatsAppButton;